import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { wareHouseReceiptsTypes } from './actionTypes';
import { getListFail, getListSuccess, getMilestoneConfigWRFail, getMilestoneConfigWRSuccess } from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchWR = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};


export const fetchList = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetWhareHouseReceipts(WareHouseReceipt: {
        userId: ${user.id || ''},
        initial_date: "${from || ''}",
        final_date: "${to + ' 11:59:00' || ''}",
        order : "${order}",
        ${dynamicFilterCF}
        ${dynamicFilter}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        wharehouseReceiptData {
          id
          clientId
          CreatedOn
          Number
          CreatedByName
          Version
          ModeOfTransportCode
          IssuedByName
          ShipperName
          ConsigneeName
          CreatorNetworkID
          TotalPieces
          TotalWeight
          TotalVolume
          TotalVolumeWeight
          ChargeableWeight
          TotalValue
          Status
          HasAttachments
          LastItemID
          IsOnline
          IsLiquidated
          AreaPrecision  
          BondedWarehouseType
          DbClassType
          IsOnlineTransaction
          IsTrackingEmailSent
          LengthPrecision
          LengthUnit
          Type
          VolumePrecision
          VolumeUnit
          VolumeWeightPrecision
          WeightPrecision
          WeightUnit
          VolumeWeightUnit
          VolumeWeightFactor
          BondedWarehouseNumber
          CarrierBookingNumber
          CarrierName
          CarrierPRONumber
          CarrierTrackingNumber
          CreatedBy
          DocumentTemplateName
          DriverLicenseNumber
          DriverName
          Notes
          SupplierInvoiceNumber
          SupplierName
          SupplierPONumber
          DestinationAgentName
          GUID
          customFields {
            name
            value
            internalName
          }
        }
        CountItems
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetWhareHouseReceipts;
};

function* fetchListSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchList, data.payload);
        yield put(getListSuccess(response));
    } catch (error) {
        yield put(getListFail(error));
    }
}

function* getMilestoneConfigWR(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, {
      OperationType: "WH",
      ...data.payload,
    });
    yield put(getMilestoneConfigWRSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigWRFail(error));
  }
}

function* wharehouseReceiptSaga() {
    yield takeLatest(wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS, fetchListSaga);
    yield takeLatest(wareHouseReceiptsTypes.GET_MILESTONESCONFIG_WR, getMilestoneConfigWR)
}

export default wharehouseReceiptSaga;
